import React from 'react'

const Sustainability: React.FC = () => {
  return (
    <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.67589 0.993042H4.17432V14.4117H4.67589V0.993042Z" fill="currentColor" />
      <path
        d="M3.92525 11.9139C3.66882 11.9139 2.9221 11.88 2.15156 11.5231C1.28071 11.1205 0.219879 10.2217 0.107652 8.22421C0.00796455 6.45363 0.912677 5.00055 1.76911 3.77803C2.87571 2.19672 4.15785 0.819462 4.17039 0.805899L4.52839 0.500732L4.70958 0.957557L4.53968 1.13942C4.52714 1.15299 3.26819 2.50558 2.18166 4.05792C1.37287 5.21386 0.517061 6.58186 0.607971 8.1977C0.686969 9.6064 1.2782 10.5755 2.3641 11.0774C3.18355 11.4565 3.9823 11.4201 3.99108 11.4201L4.24124 11.4072L4.26757 11.8998L4.01679 11.9127C4.01052 11.9127 3.97791 11.9146 3.92462 11.9146L3.92525 11.9139Z"
        fill="currentColor"
      />
      <path
        d="M4.98288 11.9131C4.92959 11.9131 4.89824 11.9118 4.89385 11.9112L4.64307 11.8983L4.66877 11.4057L4.91893 11.4186C4.92269 11.4186 5.31267 11.4359 5.82051 11.3206L6.06503 11.2651L6.17788 11.7454L5.93336 11.8009C5.49825 11.8995 5.14213 11.9125 4.98288 11.9125V11.9131Z"
        fill="currentColor"
      />
      <path
        d="M7.73447 5.69769L7.61848 5.47883C7.33635 4.9468 6.9934 4.43942 6.72568 4.05719C5.63978 2.50547 4.38083 1.15225 4.36766 1.13869L4.19775 0.956825L4.50434 0.5L4.73694 0.805166C4.74948 0.818729 6.03163 2.19598 7.13823 3.7773C7.41409 4.17124 7.76833 4.69527 8.063 5.25073L8.17899 5.46959L7.73447 5.69769Z"
        fill="currentColor"
      />
      <path
        d="M4.29003 6.43055C4.29003 6.43055 2.19533 4.80546 1.71884 4.43556L1.52197 4.28267L1.83295 3.89551L2.02982 4.0484C2.50631 4.4183 4.601 6.04338 4.601 6.04338L4.29066 6.43055H4.29003Z"
        fill="currentColor"
      />
      <path
        d="M4.3996 10.218L4.20147 10.067C4.19458 10.0621 3.50993 9.53926 2.6629 8.87036L2.46729 8.71624L2.7814 8.33154L2.97701 8.48567C3.82028 9.15148 4.50179 9.67181 4.50869 9.67674L4.70681 9.82778L4.3996 10.2174V10.218Z"
        fill="currentColor"
      />
      <path
        d="M1.75036 8.13145L0.271973 6.92681L0.460689 6.48047L2.06447 7.74675L1.75036 8.13145Z"
        fill="currentColor"
      />
      <path
        d="M5.23436 5.25987L4.07666 6.17383L4.39067 6.55841L5.54837 5.64445L5.23436 5.25987Z"
        fill="currentColor"
      />
      <path
        d="M6.24498 5.09322L5.93213 4.70729L6.12837 4.55378C6.6337 4.15737 6.91772 3.95393 6.92963 3.9453L7.13214 3.7998L7.42744 4.19806L7.22493 4.34356C7.22493 4.34356 6.93716 4.5507 6.44123 4.93909L6.24498 5.0926V5.09322Z"
        fill="currentColor"
      />
      <path
        d="M5.87075 8.63878L4.28369 9.81006L4.58478 10.2045L6.17184 9.03324L5.87075 8.63878Z"
        fill="currentColor"
      />
      <path d="M9.3087 5.49512H8.80713V14.5003H9.3087V5.49512Z" fill="currentColor" />
      <path
        d="M8.70593 12.7947C8.35421 12.7947 6.14039 12.6942 5.99995 10.2029C5.93036 8.96929 6.55607 7.9644 7.14792 7.11857C7.90655 6.03477 8.7586 5.11927 8.79434 5.08105L9.02694 4.77588L9.33353 5.2327L9.16425 5.41457C9.15547 5.42382 8.29966 6.34363 7.56109 7.39846C7.01626 8.17648 6.44008 9.09753 6.50089 10.1758C6.62503 12.3841 8.64136 12.3064 8.72662 12.3021L8.97741 12.2891L9.00374 12.7817L8.75358 12.7947C8.75358 12.7947 8.7354 12.7953 8.70656 12.7953L8.70593 12.7947Z"
        fill="currentColor"
      />
      <path
        d="M9.38722 12.7945C9.35838 12.7945 9.34271 12.7939 9.3402 12.7939L9.09004 12.781L9.11637 12.2884L9.36716 12.3013C9.45117 12.305 11.4694 12.3729 11.5929 10.175C11.6537 9.09678 11.0775 8.17574 10.5327 7.39772C9.79349 6.34166 8.93831 5.42308 8.93016 5.41383L8.76025 5.23196L9.12954 4.89844L9.29945 5.0803C9.33518 5.11853 10.1872 6.03403 10.9459 7.11783C11.5377 7.96305 12.1634 8.96855 12.0938 10.2022C11.9534 12.6934 9.73895 12.7945 9.38722 12.7945Z"
        fill="currentColor"
      />
      <path
        d="M7.17741 7.11261L6.86572 7.49902L9.11401 9.25249L9.42569 8.86608L7.17741 7.11261Z"
        fill="currentColor"
      />
      <path
        d="M9.02075 11.6702L6.12354 9.40643L6.31163 8.89844L9.33486 11.2861L9.02075 11.6702Z"
        fill="currentColor"
      />
      <path
        d="M8.95192 9.27223L8.67041 8.77903L10.8403 7.05469L11.157 7.43692L8.95192 9.27223Z"
        fill="currentColor"
      />
      <path
        d="M11.7378 8.9634L8.68213 11.3766L8.99621 11.7611L12.0519 9.34793L11.7378 8.9634Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Sustainability
